'use client';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import clsx from 'clsx';

import { publicEnv } from '@/lib/env';
import { ImageWrapper } from '@/modules/players/v2/ImageWrapper';
import { PlayerData } from '@/types/players.types';
import { getSponsorImageByPriority } from '@/utils/helpers/getSponsorImageByPriority';

type PlayerSponsorsProps = {
  player: PlayerData | undefined;
};

export const PlayerSponsors = ({ player }: PlayerSponsorsProps) => {
  const sponsorImages = player?.sponsors.map((sponsor) => {
    const priorityImage = getSponsorImageByPriority(sponsor.sponsorImages);
    const imageUrl =
      priorityImage?.url || `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/placeholder.jpg`;
    return { title: sponsor.title, imageUrl, link: sponsor.url };
  });
  return player && sponsorImages && sponsorImages.length > 0 ? (
    <div className='flex h-full flex-col rounded-xl border shadow-md'>
      <div className='p-6 text-2xl font-bold text-gray-900'>{player.firstName}&apos;s Sponsors</div>
      <div
        className={clsx(
          'flex items-center border-t p-6 sm:justify-start',
          player?.sponsors.length > 2 ? 'justify-center' : 'justify-start'
        )}
      >
        <div className='grid grid-cols-3 gap-4 sm:flex sm:flex-wrap'>
          {sponsorImages.map((sponsor, index) => {
            return (
              <div
                className='size-[80px] rounded-lg border border-gray-300 sm:size-[100px] bg-white'
                key={index}
              >
                <a
                  href={sponsor?.link}
                  target='_blank'
                  aria-label={`Link to ${sponsor?.title} page (opens in a new tab)`}
                  rel='noreferrer'
                >
                  <ImageWrapper
                    src={getCDNURL(sponsor?.imageUrl, 200, 200)}
                    height={100}
                    width={100}
                    className='size-full object-contain'
                    alt={`${sponsor?.title} Logo`}
                    fill={false}
                  />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : null;
};
